"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CLASS_PREFIX = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _uiBox = _interopRequireDefault(require("ui-box"));

var _buttons = require("../../buttons");

var _textInput = require("../../text-input");

var _safeInvoke = _interopRequireDefault(require("../../lib/safe-invoke"));

var CLASS_PREFIX = 'evergreen-file-picker';
exports.CLASS_PREFIX = CLASS_PREFIX;

var FilePicker =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(FilePicker, _PureComponent);

  function FilePicker() {
    var _this;

    (0, _classCallCheck2.default)(this, FilePicker);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FilePicker).call(this));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fileInputRef", function (node) {
      _this.fileInput = node;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleFileChange", function (e) {
      // Firefox returns the same array instance each time for some reason
      var files = (0, _toConsumableArray2.default)(e.target.files);

      _this.setState({
        files: files
      });

      (0, _safeInvoke.default)(_this.props.onChange, files);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleButtonClick", function () {
      _this.fileInput.click();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleBlur", function (e) {
      if (e && e.target) e.target.files = _this.state.files;
      (0, _safeInvoke.default)(_this.props.onBlur, e);
    });
    _this.state = {
      files: []
    };
    return _this;
  }

  (0, _createClass2.default)(FilePicker, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          name = _this$props.name,
          accept = _this$props.accept,
          required = _this$props.required,
          multiple = _this$props.multiple,
          disabled = _this$props.disabled,
          capture = _this$props.capture,
          height = _this$props.height,
          onChange = _this$props.onChange,
          props = (0, _objectWithoutProperties2.default)(_this$props, ["name", "accept", "required", "multiple", "disabled", "capture", "height", "onChange"]);
      var files = this.state.files;
      var inputValue;

      if (files.length === 0) {
        inputValue = '';
      } else if (files.length === 1) {
        inputValue = files[0].name;
      } else {
        inputValue = "".concat(files.length, " files");
      }

      var buttonText;

      if (files.length === 0) {
        buttonText = 'Select file';
      } else if (files.length === 1) {
        buttonText = 'Replace file';
      } else {
        buttonText = 'Replace files';
      }

      return _react.default.createElement(_uiBox.default, (0, _extends2.default)({
        display: "flex",
        className: "".concat(CLASS_PREFIX, "-root")
      }, props), _react.default.createElement(_uiBox.default, {
        innerRef: this.fileInputRef,
        className: "".concat(CLASS_PREFIX, "-file-input"),
        is: "input",
        type: "file",
        name: name,
        accept: accept,
        required: required,
        multiple: multiple,
        disabled: disabled,
        capture: capture,
        onChange: this.handleFileChange,
        display: "none"
      }), _react.default.createElement(_textInput.TextInput, {
        className: "".concat(CLASS_PREFIX, "-text-input"),
        readOnly: true,
        value: inputValue,
        placeholder: "Select a file to upload\u2026" // There's a weird specifity issue when there's two differently sized inputs on the page
        ,
        borderTopRightRadius: "0 !important",
        borderBottomRightRadius: "0 !important",
        height: height,
        flex: 1,
        textOverflow: "ellipsis",
        onBlur: this.handleBlur
      }), _react.default.createElement(_buttons.Button, {
        className: "".concat(CLASS_PREFIX, "-button"),
        onClick: this.handleButtonClick,
        disabled: disabled,
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
        height: height,
        flexShrink: 0,
        type: "button",
        onBlur: this.handleBlur
      }, buttonText));
    }
  }]);
  return FilePicker;
}(_react.PureComponent);

exports.default = FilePicker;
FilePicker.displayName = "FilePicker";
(0, _defineProperty2.default)(FilePicker, "propTypes", {
  /**
   * Name attribute of the input.
   */
  name: _propTypes.default.string,

  /**
   * The accept attribute of the input.
   */
  accept: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),

  /**
   * When true, the file picker is required.
   */
  required: _propTypes.default.bool,

  /**
   * When true, accept multiple files.
   */
  multiple: _propTypes.default.bool,

  /**
   * When true, the filepicker is disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * The capture attribute of the input.
   */
  capture: _propTypes.default.bool,

  /**
   * The height of the file picker.
   */
  height: _propTypes.default.number,

  /**
   * Function called when onChange is fired
   */
  onChange: _propTypes.default.func,

  /**
   * Function called when onBlur is fired
   */
  onBlur: _propTypes.default.func
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/evergreen-ui/commonjs/file-picker/src/FilePicker.js
// module id = 159
// module chunks = 0